import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
import { useSettingsContext } from '../../contexts/settings';

const Search = () => {
	const { searchQuery, setSearchQuery } = useFiltersContext();
	const [value, setValue] = React.useState(searchQuery);
	const settings = useSettingsContext();
	React.useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (setSearchQuery) {
				setSearchQuery(value);
			}
		}, 600);

		return () => clearTimeout(delayDebounceFn);
	}, [value]);

	React.useEffect(() => {
		if (!searchQuery.length) {
			setValue('');
		}
	}, [searchQuery]);

	const searchParentRef = React.useRef<HTMLDivElement | null>(null);
	const handleOnFocus = () => {
		if (null !== searchParentRef.current) {
			searchParentRef.current.classList.add('pfa-search--focus');
		}
	};

	const handleOnBlur = () => {
		if (null !== searchParentRef.current) {
			searchParentRef.current.classList.remove('pfa-search--focus');
		}
	};

	if (settings.showSearch) {
		return (
			<div className="pfa-search">
				{settings.layout === 'default' && (
					<div className="pfa-filters-bar__title">{settings.searchTitle}</div>
				)}
				<div className="pfa-search__wrapper" ref={searchParentRef}>
					<input
						className="pfa-search__input"
						type="text"
						value={value}
						onChange={(e) => setValue(e.target.value)}
						placeholder="Enter keywords(s)..."
						onFocus={() => handleOnFocus()}
						onBlur={() => handleOnBlur()}
					/>

					<button className="pfa-search__icon" onClick={() => setValue('')}>
						{!!value.length ? (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_1789_161979)">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M12.0887 14.74C12.5023 15.1406 12.7527 15.3815 12.7527 15.3815C12.7527 15.3815 16.289 19.1258 17.5637 20.1926L20.4271 17.558L14.8266 11.9575C15.5493 11.1989 16.4735 10.2222 17.3175 9.32803L20.3858 6.44283C20.1913 6.29937 19.7081 5.88766 19.3316 5.38856C18.955 4.88946 17.9401 4.04822 17.4798 3.68999L14.8203 6.50851C13.9761 7.3309 12.9992 8.30959 12.0747 9.24605C11.3033 8.51108 10.2802 7.5437 9.347 6.6636L6.46309 3.59395C6.31725 3.79087 5.89924 4.28037 5.39398 4.66307C4.88871 5.04577 4.0344 6.07371 3.67041 6.53984L6.49005 9.19819C7.34351 10.0746 8.36557 11.0939 9.33406 12.049C8.89998 12.4968 8.63643 12.7706 8.63643 12.7706C8.63643 12.7706 4.89359 16.3084 3.82532 17.5816L6.42177 20.4069L12.0887 14.74Z"
										fill="#133C55"
									/>
								</g>
								<defs>
									<clipPath id="clip0_1789_161979">
										<rect width="24" height="24" fill="white" />
									</clipPath>
								</defs>
							</svg>
						) : (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M4.61594 4.47348C1.44296 7.64646 1.44296 12.7909 4.61594 15.9638C7.50903 18.8569 12.0411 19.1121 15.2233 16.7294L20.5502 22.0564L21.9645 20.6421L16.6663 15.344C19.2668 12.1528 19.0801 7.44728 16.1063 4.47348C12.9333 1.30051 7.78891 1.30051 4.61594 4.47348ZM6.03015 14.5496C3.63822 12.1577 3.63822 8.27962 6.03015 5.8877C8.42208 3.49577 12.3002 3.49577 14.6921 5.8877C17.084 8.27962 17.084 12.1577 14.6921 14.5496C12.3002 16.9416 8.42208 16.9416 6.03015 14.5496Z"
									fill="#133C55"
								/>
							</svg>
						)}
					</button>
				</div>
			</div>
		);
	}

	return <></>;
};

Search.displayName = 'Search';

export default Search;
